import axios from 'axios';
import authHeader from '../../auth-header';

import tokenHeader from '../../token-header';

import baseUrl from '../../base-url';

const API_URL = baseUrl() + "/api/all/";

const getDokumen = 'dokumen-pendukung-anggota-umum';
const postDokumenUrl = 'dokumen-pendukung-anggota-umum';
const putDokumen = 'dokumen-pendukung-anggota-umum/';
const deleteDokumen = 'dokumen-pendukung-anggota-umum/';

class DokumenAnggotaUmumService {

    postDokumen(formData) {
        return axios
        .post(
            API_URL + postDokumenUrl ,
            formData,
            { headers: authHeader() }
        );
    }

    putDokumen(formData) {
        return axios
        .put(
            API_URL + putDokumen + formData.id_dokumen_pendukung,
            formData,
            { headers: authHeader() }
        );
    }

    deleteDokumen(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteDokumen + formData.id_dokumen_pendukung,
                { headers: authHeader() }
            );
    }

    getDokumen(currentPage, pageSize, filter) {

        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
        };
        
        return axios.get(
            API_URL + getDokumen ,
        {
            params : data,
            headers: authHeader()
        });
    }

}

export default new DokumenAnggotaUmumService();